// Interne Module
import * as storage from '@/_helper/storage';

export function checkAccess(service) {
    if (process.env.VITE_ENV !== 'development' && service !== undefined) {
        const bookingData = storage.get('bookingData');
        if (bookingData?.data !== undefined && !bookingData.data[service]) {
            window.location.href = '#/';
        }
    }
}
